import React, { Suspense, lazy } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import AuthPage from "@/pages/AuthPage";
import AuthCallback from "@/components/AuthCallback";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/contexts/LanguageContext";

const Dashboard = lazy(() => import("@/pages/Dashboard"));
const EbooksPage = lazy(() => import("@/pages/EbooksPage"));
const EbookDetailPage = lazy(() => import("@/pages/EbookDetailPage"));
const EbookReaderPage = lazy(() => import("@/pages/EbookReaderPage"));
const SubscriptionPage = lazy(() => import("@/pages/SubscriptionPage"));
const MapasMentaisPage = lazy(() => import("@/pages/MapasMentaisPage"));
const SharedMapPage = lazy(() => import("@/pages/SharedMapPage"));
const SharedSlidesPage = lazy(() => import("@/pages/SharedSlidesPage"));
const QuestoesPage = lazy(() => import("@/pages/QuestoesPage"));
const QuizPage = lazy(() => import("@/pages/QuizPage"));
const ELawyerPage = lazy(() => import("@/pages/ELawyerPage"));
const CriarPage = lazy(() => import("@/pages/CriarPage"));
const AtualizacoesJuridicasPage = lazy(() => import("@/pages/AtualizacoesJuridicasPage"));
const AtualizacaoDetailPage = lazy(() => import("@/pages/AtualizacaoDetailPage"));
const VideosPage = lazy(() => import("@/pages/VideosPage"));
const SharedVideoPage = lazy(() => import("@/pages/SharedVideoPage"));
const GaleriaVideosPage = lazy(() => import("@/pages/GaleriaVideosPage"));

const PageLoader = () => (
  <div className="min-h-screen bg-gradient-to-br from-[#060B14] via-[#0C1527] to-[#060B14] flex items-center justify-center">
    <div className="w-10 h-10 border-3 border-[#E6C687] border-t-transparent rounded-full animate-spin" />
  </div>
);

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();

  // CRITICAL: Detect session_id synchronously during render (before any route renders)
  // This prevents race conditions with ProtectedRoute/auth checks
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/ebooks" element={<EbooksPage />} />
        <Route path="/ebooks/:id" element={<EbookDetailPage />} />
        <Route path="/ebooks/:id/read" element={<EbookReaderPage />} />
        <Route path="/subscription" element={<SubscriptionPage />} />
        <Route path="/mapas-mentais" element={<MapasMentaisPage />} />
        <Route path="/mapas-mentais/compartilhado/:token" element={<SharedMapPage />} />
        <Route path="/slides/compartilhado/:token" element={<SharedSlidesPage />} />
        <Route path="/questoes" element={<QuestoesPage />} />
        <Route path="/quiz" element={<QuizPage />} />
        <Route path="/e-lawyer" element={<ELawyerPage />} />
        <Route path="/criar" element={<CriarPage />} />
        <Route path="/atualizacoes" element={<AtualizacoesJuridicasPage />} />
        <Route path="/atualizacoes/:id" element={<AtualizacaoDetailPage />} />
        <Route path="/videos" element={<VideosPage />} />
        <Route path="/videos/compartilhado/:token" element={<SharedVideoPage />} />
        <Route path="/galeria" element={<GaleriaVideosPage />} />
      </Routes>
    </Suspense>
  );
}

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
